module.exports = __webpack_public_path__ + "img/gsgc2902_2.39cc9158.svg";